import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaArrowLeft } from 'react-icons/fa';

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: 12px;
  color: var(--color-text-primary);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  align-self: flex-start;

  &:hover {
    border: 1px solid var(--color-border-primary);
    box-shadow: var(--shadow-sm);
    transform: translateY(-1px);
  }
`;

const AdminSettingsBackLink = () => {
  const navigate = useNavigate();

  return (
    <BackButton type="button" onClick={() => navigate('/admin/settings')}>
      <FaArrowLeft />
      Voltar às configurações
    </BackButton>
  );
};

export default AdminSettingsBackLink;
